export const control_oyo_broker_constants = {
	CREDIT_REQUEST_VIEW: "CreditRequestView",
	CREDIT_REQUEST_EDIT: "CreditRequestEdit",
	CREDIT_REQUEST_SAVE: "CreditRequestSave",
	CREDIT_REQUEST_LIST_VIEW:"CreditRequestListView"
};